import { FC } from 'react';

import { TeamMemberRole } from '__generated__/GQL';
import Button from 'components/_core/Button';
import useToast from 'components/ToastProvider/useToast';
import { getHighestRole } from 'features/Team/utils';

import TeamMemberModal from '../TeamMemberModal';
import useLockCompanyUser from './graphql/useLockCompanyUser';
import locales from './locales';

interface LockTeamMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: {
    companyUserOrInvitationId: string;
    firstName: string;
    lastName: string;
    roles: TeamMemberRole[] | null;
  };
}

const LockTeamMemberModal: FC<LockTeamMemberModalProps> = ({
  isOpen,
  onClose,
  user: { companyUserOrInvitationId, firstName, lastName, roles },
}) => {
  const { showToast } = useToast();

  const [lockCompanyUserMutation, { loading }] = useLockCompanyUser(
    companyUserOrInvitationId,
  );

  const onSubmit = async () => {
    await lockCompanyUserMutation();
    showToast({
      message: locales.formatString(locales.success, {
        firstName,
        lastName,
      }) as string,
      type: 'success',
    });
  };

  const roleToConsider = getHighestRole(roles ?? []);

  const modalDescription = roleToConsider
    ? locales.description[roleToConsider]
    : '';

  return (
    <TeamMemberModal
      description={modalDescription}
      footer={
        <>
          <Button
            isDisabled={loading}
            onClick={onClose}
            variant="inline-primary"
          >
            {locales.cancel}
          </Button>

          <Button isLoading={loading} onClick={onSubmit} variant="danger">
            {locales.ctaLabel}
          </Button>
        </>
      }
      isOpen={isOpen}
      title={locales.formatString(locales.title, {
        firstName,
        lastName,
      })}
    />
  );
};

export default LockTeamMemberModal;
